import { render } from "./CropperComponent.vue?vue&type=template&id=4574d562&scoped=true"
import script from "./CropperComponent.vue?vue&type=script&lang=js"
export * from "./CropperComponent.vue?vue&type=script&lang=js"

import "./CropperComponent.vue?vue&type=style&index=0&id=4574d562&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4574d562"]])

export default __exports__